import * as Styles from "./CustomSnackBar.styles";

interface CustomSnackBarProps {
  message: string;
  onClose: () => void;
  open: boolean;
}

const DEFAULT_OPEN_CLOSE_INTERVAL = 5000;

export default function CustomSnackBar({ open, message, onClose }: CustomSnackBarProps) {
  return (
    <Styles.StyledSnackbar
      open={open}
      autoHideDuration={DEFAULT_OPEN_CLOSE_INTERVAL}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Styles.StyledAlert onClose={onClose} severity="error">
        {message}
      </Styles.StyledAlert>
    </Styles.StyledSnackbar>
  );
}
